<template>
  <div>
    <v-dialog v-model="isModalOpen" max-width="630px" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Result</v-toolbar-title>
      </v-toolbar>
      <ResultCard :success="success" :successMsgTitle="successMsgTitle" :successMsgSubtitle="successMsgSubtitle" :failedMsgTitle="failedMsgTitle" :failedMsgSubtitle="failedMsgSubtitle" :successActions="successActions" :failedActions="failedActions" />
    </v-dialog>
  </div>
</template>

<script>
  import ResultCard from "@/components/ResultCard";

  export default {
    name: "ResultModal",
    props: {
      isModalOpen: {
        type: Boolean,
        required: true,
        default: false,
      },
      success: {
        type: Boolean,
        required: true,
      },
      successMsgTitle: {
        type: String,
        default: "Success!",
      },
      successMsgSubtitle: {
        type: String,
      },
      failedMsgTitle: {
        type: String,
        default: "Opps!",
      },
      failedMsgSubtitle: {
        type: String,
      },
      successActions: {
        type: Array,
      },
      failedActions: {
        type: Array,
      },
    },
    components: {
      ResultCard,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ResultModal.vue